export default __webpack_public_path__ + "img/17.973d5b74.jpg";